import { Link } from "react-router-dom";
import { Phone, EnvelopeSimple, MapPin, ArrowUpRight, InstagramLogo, FacebookLogo, WhatsappLogo } from "@phosphor-icons/react";
import { CLINIC, IMAGES } from "../data/site";

export const Footer = () => (
  <footer className="border-t border-border bg-secondary/40" data-testid="site-footer">
    <div className="mx-auto grid max-w-7xl grid-cols-1 gap-12 px-5 py-16 sm:px-8 md:grid-cols-2 lg:grid-cols-4">
      <div>
        <div className="flex items-center gap-3">
          <img src={IMAGES.logo} alt="DK Aesthetics" className="h-12 w-12 rounded-full border border-border object-cover" />
          <div>
            <p className="font-display text-xl font-medium">DK <span className="text-primary">Aesthetics</span></p>
            <p className="text-[10px] uppercase tracking-[0.3em] text-muted-foreground">Harley Street Trained</p>
          </div>
        </div>
        <p className="mt-5 max-w-xs text-sm font-light leading-relaxed text-muted-foreground">
          A trusted skin care clinic led by registered dental professional Dee Kaur — advanced facial
          aesthetics with a focus on safety, precision and natural-looking results.
        </p>
        <div className="mt-5 flex gap-3">
          <a href={CLINIC.whatsapp} target="_blank" rel="noopener noreferrer" aria-label="WhatsApp" data-testid="footer-whatsapp-link" className="border border-border p-2.5 transition-colors duration-300 hover:border-primary hover:text-primary">
            <WhatsappLogo size={18} />
          </a>
          <a href="https://www.facebook.com/DKCosmeticUK" target="_blank" rel="noopener noreferrer" aria-label="Facebook" data-testid="footer-facebook-link" className="border border-border p-2.5 transition-colors duration-300 hover:border-primary hover:text-primary">
            <FacebookLogo size={18} />
          </a>
          <a href="https://www.instagram.com/dk_aestheticsuk" target="_blank" rel="noopener noreferrer" aria-label="Instagram" data-testid="footer-instagram-link" className="border border-border p-2.5 transition-colors duration-300 hover:border-primary hover:text-primary">
            <InstagramLogo size={18} />
          </a>
        </div>
      </div>

      <div>
        <p className="text-xs font-medium uppercase tracking-[0.3em] text-primary">Explore</p>
        <ul className="mt-5 space-y-3 text-sm font-light">
          {[
            ["Home", "/"],
            ["Treatments & Pricing", "/treatments"],
            ["Meet the Team", "/team"],
            ["Blog", "/blog"],
            ["Contact & Booking", "/contact"],
          ].map(([label, to]) => (
            <li key={to}>
              <Link to={to} data-testid={`footer-link-${label.toLowerCase().replace(/[^a-z]+/g, "-")}`} className="text-foreground/80 transition-colors duration-300 hover:text-primary">
                {label}
              </Link>
            </li>
          ))}
          <li>
            <a href={CLINIC.alumierUrl} target="_blank" rel="noopener noreferrer" data-testid="footer-alumier-link" className="inline-flex items-center gap-1 text-foreground/80 transition-colors duration-300 hover:text-primary">
              Alumier MD Online Shop <ArrowUpRight size={13} />
            </a>
          </li>
        </ul>
      </div>

      <div>
        <p className="text-xs font-medium uppercase tracking-[0.3em] text-primary">Opening Hours</p>
        <p className="mt-5 text-[11px] uppercase tracking-[0.2em] text-muted-foreground">Derby — Draycott Clinic</p>
        <ul className="mt-2 space-y-1.5 text-sm font-light">
          {CLINIC.hoursDerby.map((h) => (
            <li key={h.day} className="flex justify-between gap-6"><span>{h.day}</span><span className="text-muted-foreground">{h.time}</span></li>
          ))}
        </ul>
        <p className="mt-4 text-[11px] uppercase tracking-[0.2em] text-muted-foreground">Nottingham — Manor Dental</p>
        <ul className="mt-2 space-y-1.5 text-sm font-light">
          {CLINIC.hoursNottingham.map((h) => (
            <li key={h.day} className="flex justify-between gap-6"><span>{h.day}</span><span className="text-muted-foreground">{h.time}</span></li>
          ))}
        </ul>
      </div>

      <div>
        <p className="text-xs font-medium uppercase tracking-[0.3em] text-primary">Contact</p>
        <ul className="mt-5 space-y-4 text-sm font-light">
          <li>
            <a href={CLINIC.phoneHref} data-testid="footer-phone-link" className="flex items-start gap-3 transition-colors duration-300 hover:text-primary">
              <Phone size={17} className="mt-0.5 shrink-0 text-primary" /> {CLINIC.phone}
            </a>
          </li>
          <li>
            <a href={`mailto:${CLINIC.email}`} data-testid="footer-email-link" className="flex items-start gap-3 transition-colors duration-300 hover:text-primary">
              <EnvelopeSimple size={17} className="mt-0.5 shrink-0 text-primary" /> {CLINIC.email}
            </a>
          </li>
          <li>
            <a href={CLINIC.directionsUrl} target="_blank" rel="noopener noreferrer" data-testid="footer-directions-link" className="flex items-start gap-3 transition-colors duration-300 hover:text-primary">
              <MapPin size={17} className="mt-0.5 shrink-0 text-primary" /> {CLINIC.address}
            </a>
          </li>
        </ul>
      </div>
    </div>
    <div className="border-t border-border">
      <div className="mx-auto flex max-w-7xl flex-col items-start justify-between gap-2 px-5 py-6 text-xs text-muted-foreground sm:flex-row sm:items-center sm:px-8">
        <p>© {new Date().getFullYear()} {CLINIC.legalName}. All rights reserved.</p>
        <p className="uppercase tracking-[0.2em]">Skin Clinic · Derby | Nottingham</p>
      </div>
    </div>
  </footer>
);
